// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
export const environment = {
  production: true,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '/',
  appId: 'LoomTenantManagement',
  defaultPage: 'HomePage',
  windowsAuthentication: false,
  semanticVersion: '1.0.9'
};